/** How long a search box waits after the last keystroke before its results are recomputed */
export const SEARCH_DEBOUNCE = 400;
